import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 500,
    maxHeight: '80vh',
    '& .MuiDialogContent-root': {
      padding: theme.spacing(12)
    },
    // Reskin: size to the content so the buttons sit the dialog's padding above its bottom edge.
    ...reskinStyles(theme, { minHeight: 0 })
  },
  modalHeader: {
    marginBottom: theme.spacing(6)
  },
  modalContent: {
    marginBottom: theme.spacing(6),
    lineHeight: 1.5
  },
  content: {
    maxHeight: 'calc(80vh - 200px)',
    overflowY: 'auto'
  },
  icon: {
    height: 32,
    marginBottom: theme.spacing(2)
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(7)
  },
  submitBtn: {
    padding: theme.spacing(1, 2),
    width: 150,
    height: 36
  },
  noBtn: {
    padding: theme.spacing(1, 2),
    minWidth: 137,
    height: 36
  },
  link: {
    color: theme.colorPalette.orange_50,
    textDecoration: 'underline !important',
    fontSize: 16,
    padding: theme.spacing(0),
    marginBottom: theme.spacing(1),
    // Reskin: an inline green text link, with no pill hover behind it.
    ...reskinStyles(theme, {
      ...theme.actionStyles.link,
      verticalAlign: 'baseline',
      marginBottom: 0,
      '&:hover': { ...theme.actionStyles.link['&:hover'], backgroundColor: 'transparent' }
    })
  },
  confirmModalContainer: {
    minWidth: 580,
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.colors.modal__background_primary,
    padding: theme.spacing(6)
  }
}));

export default useStyles;
